export default {
  common: {
    account: 'Hesap',
    agents: 'Ajanlar',
    all: 'Tümü',
    available: 'Kullanılabilir',
    cancel: 'İptal',
    cloud: 'Bulut',
    copy: 'Kopyala',
    current: 'geçerli',
    delete: 'Sil',
    error: 'Hata',
    export: 'Dışa aktar',
    help: 'Yardım',
    home: 'Ana sayfa',
    language: 'Dil',
    links: 'Bağlantılar',
    loading: 'yükleniyor',
    local: 'Yerel',
    login: 'Giriş',
    logout: 'Çıkış',
    metadata: 'Meta veri',
    more: 'Daha fazla',
    name: 'Ad',
    never: 'Asla',
    none: 'yok',
    notes: 'Notlar',
    ok: 'Tamam',
    open: 'Aç',
    password: 'şifre',
    project: 'proje',
    projects: 'Projeler',
    publicLink: 'Herkese açık bağlantı',
    register: 'Kayıt ol',
    remove: 'Kaldır',
    save: 'Kaydet',
    search: 'Ara',
    settings: 'Ayarlar',
    subscribe: 'Abone ol',
    track: 'parça',
    tracks: 'Parçalar',
    unknown: 'Bilinmiyor',
    unknownArtist: 'Bilinmeyen sanatçı',
    upload: 'Yükle',
    username: 'kullanıcı adı'
  },
  time: {
    day: 'gün',
    days: 'gün',
    daysAgo: (ctx) => `${ctx.named('count')} gün önce`,
    hoursAgo: (ctx) => `${ctx.named('count')} saat önce`,
    minutesAgo: (ctx) => `${ctx.named('count')} dakika önce`,
    rightNow: 'hemen şimdi',
    duration: (ctx) => {
      const minutes = Number(ctx.named('minutes'))
      const seconds = Number(ctx.named('seconds'))
      if (minutes > 0) return `${minutes} dakika ${seconds} saniye`
      return `${seconds} saniye`
    }
  },
  topBar: {
    accountFallback: 'Hesap',
    storage: 'Depolama',
    language: 'Dil'
  },
  commandPalette: {
    placeholder: 'Parça ve proje ara...',
    projects: 'Projeler',
    tracks: 'Parçalar',
    pages: 'Sayfalar',
    noResults: 'Sonuç bulunamadı',
    quickLinks: 'Hızlı bağlantılar',
    page: {
      home: 'Ana sayfa',
      account: 'Hesap',
      agents: 'Ajanlar',
      links: 'Bağlantılar',
      settings: 'Ayarlar',
      help: 'Yardım'
    }
  },
  explorer: {
    searchTitle: 'Ara',
    trackCount: (ctx) => `${ctx.named('count')} parça`
  },
  emptyState: {
    hello: 'merhaba',
    addTrack: 'Parça ekle',
    addTrackSubtitle: 'başlamak için',
    dragDrop: 'Sürükle ve bırak',
    dragDropSubtitle: 'dosyalarını hızlı yüklemek için',
    switchStorage: 'Geçiş yap',
    switchStorageSubtitle: 'üst menüden bulut ve yerel arasında',
    installAgent: 'Ajan kur',
    installAgentSubtitle: 'dosyalarını otomatik yüklemek için',
    playTrack: 'Parça çal',
    playTrackSubtitle: 'efektleri kullanmak için alt oynatıcıyı aç',
    community: 'soruların mı var? {discord} ve {telegram} topluluklarımıza katıl.'
  },
  create: {
    createProject: 'Proje oluştur',
    uploadTrack: 'Parça yükle',
    newProject: 'Yeni Proje',
    artist: 'Sanatçı',
    name: 'Ad',
    create: 'Oluştur',
    loading: 'Yükleniyor...',
    uploadCover: 'Kapak yükle'
  },
  upload: {
    ariaLabel: 'Parça yükle',
    uploadTrack: 'Parça yükle',
    analyzing: 'Analiz ediliyor...',
    fileAdded: '"{name}" dosyası eklendi',
    fileReadError: 'Dosya okuma hatası.',
    errorWithMessage: 'Hata: {message}'
  },
  dragDrop: {
    dropToUpload: 'Yüklemek için bırak',
    deleteDrop: 'Parçayı kalıcı olarak silmek için buraya bırak'
  },
  project: {
    upload: 'Yükle',
    noTracks: 'Parça yok',
    createdBy: 'oluşturan',
    trackSummary: (ctx) => `${ctx.named('count')} parça, ${ctx.named('duration')}`,
    play: 'Çal',
    pause: 'Duraklat'
  },
  trackItem: {
    more: 'Daha fazla',
    copyPublicLink: 'Herkese açık bağlantıyı kopyala',
    savedLocally: 'Yerel olarak kaydedildi',
    saveLocal: 'Yerel depolamaya kaydet',
    saving: 'Kaydediliyor...',
    saveCloud: 'Buluta kaydet',
    deleteTrack: 'Parçayı sil',
    moveUp: 'Yukarı taşı',
    moveDown: 'Aşağı taşı',
    removeFromProject: '{project} projesinden kaldır',
    moveToProject: 'Projeye taşı',
    currentProject: '(geçerli)',
    confirmDelete: 'Bu parçayı silmek istediğine emin misin?',
    linkCopiedTitle: 'Bağlantı kopyalandı',
    linkCopiedDescription: 'Herkese açık bağlantı panoya kopyalandı'
  },
  trackView: {
    created: '{time} oluşturuldu',
    tabs: {
      notes: 'Notlar',
      metadata: 'Meta veri'
    },
    notFound: 'parça bulunamadı veya sana açık değil',
    untitled: 'Adsız'
  },
  notes: {
    placeholder: 'Bu parça hakkında not ekle...',
    saving: 'Kaydediliyor...',
    saveError: 'Notlar kaydedilemedi. Lütfen tekrar dene.'
  },
  metadata: {
    trackOrder: 'Parça sırası',
    artist: 'Sanatçı',
    name: 'Ad',
    key: 'Ton',
    mode: 'Mod',
    deleteTrack: 'Parçayı sil',
    saveError: 'Meta veri kaydedilemedi. Lütfen tekrar dene.'
  },
  lufs: {
    momentary: 'Anlık LUFS',
    shortTerm: 'Kısa süreli LUFS',
    integrated: 'Entegre LUFS'
  },
  effects: {
    pitchshift: 'Pitchshift',
    speed: 'Hız',
    balance: 'Denge',
    volume: 'Ses',
    reverberation: 'Reverb',
    distortion: 'Distortion',
    bitcrush: 'Bitcrush',
    saveCurrentEffectsAs: 'Geçerli efektleri şu adla kaydet',
    presetName: 'Ad',
    add: 'Ekle',
    availablePresets: 'Kullanılabilir presetler',
    tune: 'Ayar',
    eq: 'EQ',
    fx: 'FX',
    presets: 'Presetler',
    center: 'Merkez',
    left: 'Sol',
    right: 'Sağ'
  },
  exportPanel: {
    applyEffects: 'Geçerli efektleri uygula',
    applyEffectsSubtitle: 'Parçayı geçerli efektlerle dışa aktar',
    exportWav: 'WAV olarak dışa aktar',
    exportMp3: 'MP3 olarak dışa aktar',
    exporting: 'Dışa aktarılıyor...',
    exportAsNewTrack: 'Yeni parça olarak dışa aktar',
    creatingTrack: 'Parça oluşturuluyor...',
    downloadOriginal: 'Orijinali indir',
    originalUnavailable: 'Orijinal dosya mevcut değil.',
    downloadOriginalFailed: 'Orijinal dosya indirilemedi.',
    exportAudioFailed: 'Parça sesi dışa aktarılamadı.',
    waveformFailed: 'Waveform oluşturulamadı.',
    createTrackFailed: 'Dışa aktarılan parça oluşturulamadı.',
    createTrackAlert: 'Dışa aktarılan parça oluşturulamadı: {message}',
    exportedSuffix: ' (dışa aktarım)',
    copySuffix: ' (kopya)'
  },
  publicLink: {
    copy: 'Kopyala',
    open: 'Aç',
    linkCopiedTitle: 'Bağlantı kopyalandı',
    linkCopiedDescription: 'Herkese açık bağlantı panoya kopyalandı'
  },
  settings: {
    tabs: {
      settings: 'Ayarlar',
      account: 'Hesap',
      links: 'Bağlantılar',
      agents: 'Ajanlar'
    },
    display: 'Görünüm',
    language: 'Dil',
    showBpm: 'Parça görünümünde BPM göster',
    showBpmSubtitle: 'Parça listesinde her parça için dakika başına vuruşu göstermek için bu ayarı aç',
    showLufs: 'Parça görünümünde LUFS göster',
    showLufsSubtitle: 'Parça listesinde her parça için loudness birimlerini göstermek için bu ayarı aç',
    showKey: 'Parça görünümünde ton göster',
    showKeySubtitle: 'Parça listesinde her parça için ton ve modu göstermek için bu ayarı aç',
    playback: 'Oynatma',
    liveLoudness: 'Canlı loudness ölçümü',
    liveLoudnessSubtitle: 'Oynatıcı ekranında canlı loudness ölçer göstermek için bu ayarı aç',
    persistEffects: 'Uygulanan efektleri tüm parçalar için koru',
    persistEffectsSubtitle: 'Parça değişse bile uygulanan efektleri açık tutmak için bu ayarı aç',
    keyboardShortcuts: 'Klavye kısayolları',
    search: 'Ara',
    pressShortcut: 'İstenen tuş kombinasyonuna bas',
    storage: 'Depolama',
    resetPresetsInfo: 'Bu tarayıcıda saklanan tüm presetleri sıfırla',
    resetPresets: 'Presetleri sıfırla',
    resetAllWarning: 'Uyarı! Aşağıdaki düğme yerel depolamadaki tüm verileri siler!',
    resetAllData: 'Tüm yerel depolamayı sıfırla ve tüm parça ile projeleri sil',
    loadingAccount: 'Hesap yükleniyor...',
    loadingLinks: 'Bağlantılar yükleniyor...',
    loadingAgents: 'Ajanlar yükleniyor...',
    authPrompt: 'Bu bölümü kullanmak için giriş yap veya kayıt ol.',
    loginRegister: 'Giriş yap veya kayıt ol',
    pageTitle: {
      settings: 'ayarlar',
      account: 'hesap ayarları',
      links: 'herkese açık bağlantılar',
      agents: 'ajanlar'
    },
    presetsCleared: 'Preset depolaması temizlendi',
    localDataDeleted: 'Tüm yerel veriler silindi',
    linkCopied: 'Bağlantı kopyalandı',
    linkCopyFailed: 'Bağlantı kopyalanamadı'
  },
  account: {
    hello: 'Merhaba {name}.',
    subscriptionStatus: 'Abonelik durumun şu anda {status}',
    noSubscription: 'Aktif aboneliğin yok.',
    manageSubscription: 'Abonelik ve ödeme yöntemlerini yönet',
    subscribeCloud: 'Bulutu kullanmak için abone ol',
    changeUsername: 'Kullanıcı adını değiştir',
    changePassword: 'Şifreyi değiştir',
    saveUsername: 'Kullanıcı adını kaydet',
    savePassword: 'Şifreyi kaydet',
    newPassword: 'yeni şifre',
    confirmPassword: 'şifreyi onayla',
    usernamePlaceholder: 'kullanıcı adın',
    storageUsage: 'Depolama kullanımı',
    baseStorage: 'Temel Depolama',
    subscriptionStorage: 'Abonelik Depolaması',
    used: 'Kullanılan',
    available: 'Kullanılabilir',
    deletedFilesNotice: 'Yakın zamanda dosya sildiysen, bunlar hala bu metriklere dahil olabilir. Merak etme - bu birkaç saat içinde değişir.',
    accountId: 'hesap id',
    currentPeriodEnds: (ctx) => `geçerli ödeme dönemi ${ctx.named('count')} ${ctx.named('label')} içinde bitiyor`,
    accessEnds: (ctx) => `abonelik erişimi ${ctx.named('count')} ${ctx.named('label')} içinde sona eriyor`,
    lastPaymentEnded: (ctx) => `son ödeme dönemi ${ctx.named('date')} tarihinde sona erdi`,
    previousBillingDate: 'önceki fatura tarihi',
    billingPortalError: 'Fatura portalı hatası',
    billingPortalFailed: 'Fatura portalı açılamadı.',
    loginRequiredUpdate: 'Profilini güncellemek için giriş yapman gerekiyor.',
    usernameEmpty: 'Kullanıcı adı boş olamaz.',
    usernameUnchanged: 'Kullanıcı adı değişmedi.',
    usernameUpdated: 'Kullanıcı adı güncellendi',
    usernameUpdateFailed: 'Kullanıcı adı güncellenemedi. Lütfen tekrar dene.',
    passwordEmpty: 'Şifre boş olamaz.',
    passwordsMismatch: 'Şifreler eşleşmiyor.',
    passwordUpdated: 'Şifre güncellendi',
    passwordUpdateFailed: 'Şifre güncellenemedi. Lütfen tekrar dene.'
  },
  links: {
    title: 'Herkese Açık Bağlantılar',
    description: 'Tüm herkese açık bağlantıların burada listelenir - bunlara erişimi olan herkes projeyi veya parçayı dinleyebilir.',
    cloudOnly: 'Herkese açık bağlantılar yalnızca Bulut modunda kullanılabilir. Herkese açık bağlantı oluşturmak ve yönetmek için Bulut depolamaya geç.',
    noLinks: 'Herkese açık bağlantı yok',
    createFirst: 'Paylaşmaya başlamak için ilk herkese açık bağlantını oluştur.',
    confirmDelete: 'Bu bağlantıyı silmek istediğine emin misin?',
    notFoundTitle: 'Bağlantı bulunamadı veya süresi doldu',
    notFoundDescription: 'Erişmeye çalıştığın bağlantı geçersiz veya süresi dolmuş.',
    unknownUser: 'bilinmiyor'
  },
  agents: {
    authorizeTitle: 'Ajanı Yetkilendir',
    authorizeDescription: 'Bu ajanın hesabına bağlanmasına izin ver.',
    loginToAuthorize: 'Bu ajanı yetkilendirmek için lütfen giriş yap.',
    wantsConnect: 'Bu ajan, ses dosyalarını otomatik yüklemek için hesabına bağlanmak istiyor.',
    permissionUpload: 'Parça yükle',
    permissionMetadata: 'Parça meta verisi oluştur',
    authorize: 'Yetkilendir',
    cancel: 'İptal',
    authorizedTitle: 'Ajan Yetkilendirildi',
    authorizedDescription: 'Artık bu pencereyi kapatıp ajan uygulamasına dönebilirsin.',
    desktopTitle: 'Masaüstü Ajanı',
    installDescription: 'Yeni render aldığın parçaları otomatik yüklemek için demoparty ajanını PC veya Mac cihazına kur.',
    warningLabel: 'UYARI: ',
    alphaWarning: 'ajan alpha aşamasında ve kararsız olabilir.',
    downloadMacApple: 'Apple Silicon Mac için indir',
    downloadMacIntel: 'Intel Mac için indir',
    downloadWindows: 'Windows x64 için indir',
    signingNotice: 'Proje hala geliştirme aşamasında olduğu için bu buildler dijital olarak imzalı değil. Başlatırken güvenlik uyarıları beklenir. İmzalı buildler daha sonra sağlanacak.',
    activeTitle: 'Aktif Ajanlar',
    connectedDescription: 'Hesabına bağlı ajanlar.',
    loginToManage: 'Ajanlarını yönetmek için lütfen giriş yap.',
    noAgents: 'Henüz bağlı ajan yok.',
    lastUsed: 'Son kullanım',
    revoke: 'Geri al',
    remove: 'Kaldır',
    confirmRemove: 'Bu ajanı kaldırmak istediğine emin misin?',
    authorizeFailed: 'Ajan yetkilendirilemedi. Lütfen tekrar dene.'
  },
  login: {
    intro: 'Bulut özelliklerini ve abonelik avantajlarını kullanmak istiyorsan giriş yapman gerekiyor. Aksi halde servisi yerel modda ücretsiz kullanabilirsin.',
    subscriptionBenefits: 'abonelik avantajları',
    login: 'Giriş',
    register: 'Kayıt ol',
    forgot: 'Şifremi unuttum',
    email: 'e-posta',
    password: 'şifre',
    repeatPassword: 'şifreyi tekrarla',
    or: 'veya',
    google: 'Google ile giriş yap',
    apple: 'Apple ile giriş yap',
    resetPassword: 'Şifreyi sıfırla',
    resetDescription: 'Yeni şifre belirleyebilmen için sana bir giriş bağlantısı göndereceğiz.',
    sendResetLink: 'Sıfırlama bağlantısı gönder',
    invalidToken: 'Geçersiz veya süresi dolmuş token',
    enterEmail: 'Lütfen e-posta adresini gir',
    resetSent: 'Bir hesap varsa, e-posta adresine giriş bağlantısı gönderdik.',
    resetFailed: 'Sıfırlama bağlantısı gönderilemedi. Lütfen tekrar dene.'
  },
  googleCallback: {
    wait: 'Lütfen bekle, girişin yapılıyor...'
  },
  subscribe: {
    cloudRequiredTitle: 'Bulut depolama gerekli',
    cloudRequiredMessage: 'Bu özellik yalnızca bulut depolama ile kullanılabilir ve aktif abonelik gerektirir.',
    title: 'Yerel başla. Otomatik yükleme için yükselt.',
    description: 'Bulut, cihazlar arasında senkronize tek bir kütüphane verir.',
    localFree: 'Uygulamayı yerel modda ücretsiz kullanabilirsin.',
    cloudIncludes: 'Buluta dahil',
    featureLibrary: 'Web ve iPhone arasında senkronize tek kütüphane',
    featureAgent: 'Yeni renderlar için masaüstü ajan otomatik yükleme',
    featureStorage: 'Parçalar için 100 GB bulut depolama',
    featureLinks: 'Parçalar ve projeler için kalıcı herkese açık bağlantılar',
    featureTools: 'Tüm yerel analiz, efekt ve dışa aktarma araçları dahil',
    monthly: 'Aylık',
    monthlyDescription: 'Bulut senkronizasyonu, istediğin zaman iptal',
    yearly: 'Yıllık',
    yearlyDescription: 'Bulut senkronizasyonu için en iyi değer',
    saveTen: '%10 tasarruf',
    perMonth: '/ay',
    billedMonthly: 'Aylık faturalandırılır',
    billedYearly: 'Yıllık $53.89 faturalandırılır',
    openingCheckout: 'Checkout açılıyor...',
    subscribePlan: '{plan} planına abone ol',
    registerSubscribe: 'Kayıt ol ve abone ol',
    securePayment: 'Polar ile güvenli ödeme. Hesap ayarlarından istediğin zaman iptal edebilirsin.',
    customPlan: 'Özel plana mı ihtiyacın var veya soruların mı var? Bize ulaş:',
    privacy: 'Gizlilik Politikası',
    terms: 'Hizmet Şartları',
    refund: 'İade Politikası',
    checkoutFailed: 'Checkout oluşturulamadı. Lütfen tekrar dene.'
  },
  thanks: {
    title: 'Aboneliğin için teşekkürler!',
    description: 'Artık bulut depolamayı kullanabilirsin. Aboneliğini yönetmek için hesap sayfasına bak.',
    startWorking: 'Çalışmaya başla',
    communities: 'Topluluklarımıza katıl',
    support: 'Sorun yaşarsan {email} üzerinden veya yukarıdaki topluluk bağlantılarıyla bize ulaş.'
  },
  help: {
    title: 'Yardım',
    intro: 'demoparty, bitmemiş müzikler ve devam eden projeler için bir workspace. Demoları saklamanı, efekt uygulamanı, tag düzenlemeni ve teknik meta verileri takip etmeni sağlar. Yerel kullanım tamamen ücretsizdir.',
    uploadTitle: 'Yükleme',
    uploadText: 'Ana sayfadaki Add düğmesine tıklayarak parça ekleyebilirsin. Yükleme sırasında sistem ton, BPM ve LUFS değerlerini otomatik algılar. Yükleme tamamlandığında onay bildirimi alırsın.',
    storageTitle: 'Depolama',
    storageText: 'demoparty iki depolama seçeneği sunar: yerel ve bulut.',
    localStorageText: 'Yerel depolama tüm verileri yalnızca cihazında tutar. Parçalar ve projeler yalnızca yüklendikleri tarayıcıda kullanılabilir. Depolama için IndexedDB kullanılır. Kayıt gerekmez ve hiçbir veri hiçbir yere gönderilmez.',
    cloudStorageText: 'Bulut depolama verilerini demoparty sunucularında tutar. Parçalarına her yerden ve her zaman erişebilirsin. Kayıt ve aktif abonelik gerekir.',
    agentsTitle: 'Ajanlar',
    agentsText: 'Bulut depolama kullanırken bir masaüstü ajanı kurabilirsin. Ajan, yeni render aldığın parçaları otomatik olarak buluta yükler.',
    publicLinksTitle: 'Herkese açık bağlantılar',
    publicLinksText: 'Bulut depolama kullanıcıları parça ve projelere herkese açık bağlantılar oluşturabilir. Proje sayfasında bağlantı düğmesine tıkla. Parçalar için parça dropdown menüsündeki aynı simgeyi kullan. Oluşturulan tüm bağlantılar Ayarlar bölümünden yönetilebilir.',
    exportTitle: 'Dışa aktarma',
    exportText: 'Parçalar, uygulanan tüm efektlerle dışa aktarılabilir. Parça sayfasını aç ve Dışa aktar seçeneğini seç. Orijinal dosyayı indirebilir veya MP3 ya da WAV olarak dışa aktarabilirsin.',
    supportTitle: 'Destek',
    supportText: "demoparty bulut abonelikleriyle ilgili sorunlar için support{'@'}demoparty.app adresinden bize ulaş.",
    attributionsTitle: 'Atıflar',
    attributionsText: 'Aşağıdaki kütüphaneler bu projeyi mümkün kıldı. Emeği geçen kendi geliştiricilerine aittir.'
  },
  cover: {
    upload: 'Kapak yükle',
    change: 'Kapağı değiştir',
    delete: 'Kapağı sil',
    loading: 'Yükleniyor...',
    selectImage: 'Lütfen bir görüntü dosyası seç',
    uploadError: 'Kapak görüntüsü yükleme hatası'
  }
}
